import { Navigate } from "react-router-dom";
import { Routes } from "@/common/config/constants";
import { useI18n } from "@/contexts/i18nContext";
import { useStore } from "@/store/store";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requiredPermission?: string;
}

const ProtectedRoute = ({
  children,
  requiredPermission,
}: ProtectedRouteProps) => {
  const { t } = useI18n();
  const auth = useStore((state) => state?.auth);

  // Handle token expiration AFTER render
  // useEffect(() => {
  //   if (
  //     auth.state.accessToken &&
  //     auth.state.exp &&
  //     auth.state.exp * 1000 <= Date.now()
  //   ) {
  //     auth.logout();
  //   }
  // }, [auth.state.accessToken, auth.state.exp, auth.logout]);

  // Wait until auth is restored
  if (!auth?.initialized) {
    return null; // should never happen now
  }

  // Not authenticated → login
  if (!auth?.state?.isAuthenticated) {
    return <Navigate to={Routes.login} replace />;
  }

  // Permission check
  if (requiredPermission && !auth.hasPermission(requiredPermission)) {
    return <Navigate to={Routes.unAuthorized} replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
